enum DiaryResources {
  classes = 'classes',
  practitioner = 'practitioner',
  room = 'room',
  list = 'list'
}

export default DiaryResources;
